<template>
    <div>
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="地区：">
                    <el-radio-group v-model.trim="formInline.region" @change="getData">
                        <el-radio v-for="item in regionList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="销售：" v-if="curRole=='admin'">
                    <el-select clearable filterable v-model.trim="formInline.sales" placeholder="请选择" @change="getData" style="width:120px">
                        <el-option
                            v-for="item in salesList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合作伙伴：" v-if="curRole=='sales'||curRole=='admin'">
                    <el-select clearable filterable v-model.trim="formInline.agent_id" placeholder="请选择" @change="getData" style="width:120px">
                        <el-option
                            v-for="item in agentsList"
                            :key="item.agent_id"
                            :label="item.company"
                            :value="item.agent_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Payer名称：">
                    <el-select v-model="formInline.payer_id" clearable filterable style="width:200px" @change="getData" placeholder="请选择Payer">
                        <el-option
                            v-for="(item, index) in payerList"
                            :key="index"
                            :label="item.name + '(' + item.payer_id + ')'"
                            :value="item.payer_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item><el-button @click="getData" type="primary" icon="Search">查询</el-button></el-form-item>
                <el-form-item><el-button @click="init()" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item v-if="curRole=='admin'"><el-button @click="getPolicyList" icon="SetUp" type="warning">策略管理</el-button></el-form-item>
                <el-form-item><el-button @click="getInviteList" icon="Magnet" type="warning">邀请列表</el-button></el-form-item>
            </el-form>
        </div>
        
        <div>
            <el-table
                :height="'calc('+(tableHeight)+'px)'"
                :data="treeTableData"
                style="width: 100%"
                row-key="id"
                stripe
                v-loading="loadingPage"
                :lazy="true"
                :load="loadOrgChildren"
                :tree-props="{
                    hasChildren: 'hasChildren',
                    indent: 16
                }"
                ref="orgTable"
            >
                <el-table-column prop="name" label="组织/OU/账户名" min-width="200">
                    <template #default="scope">
                        <span v-if="scope.row.type === 'org'">
                            <el-icon style="color:#1890ff;margin-right:4px"><i class="el-icon-office-building" /></el-icon>
                            {{ scope.row.name }}
                        </span>
                        <span v-else-if="scope.row.type === 'ou'">
                            <el-icon style="color:#e6a23c;margin-right:4px"><i class="el-icon-folder" /></el-icon>
                            {{ scope.row.name }}
                        </span>
                        <span v-else>
                            <el-icon style="color:#67c23a;margin-right:4px"><i class="el-icon-user" /></el-icon>
                            {{ scope.row.name || scope.row.Name || scope.row.Id }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="Id" label="账户ID" min-width="140">
                    <template #default="scope">
                        <span v-if="scope.row.type === 'org'">{{ scope.row.payer_id }}</span>
                        <span v-else>{{ scope.row.Id }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Email" label="邮箱" min-width="200">
                    <template #default="scope">
                        <span v-if="scope.row.type === 'org'">{{ scope.row.email }}</span>
                        <span v-else>{{ scope.row.Email }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="180">
                    <template #default="scope">
                        <template v-if="scope.row.type === 'org'">
                            <el-button @click="showInvite(scope.row)" link size="small">邀请</el-button>
                            <el-button @click="showAccountState(scope.row)" link size="small">状态</el-button>
                            <el-button @click="createNewOU(scope.row)" link size="small">新建OU</el-button>
                        </template>
                        <template v-else-if="scope.row.type === 'ou'">
                            <el-button @click="showPolicy(scope.row)" link size="small">权限</el-button>
                            <el-button @click="showInvite(scope.row)" link size="small">邀请</el-button>
                            <el-button @click="deleteOUHandler(scope.row)" link size="small" type="danger">删除</el-button>
                        </template>
                        <template v-else>
                            <el-button @click="showPolicy(scope.row)" link size="small">权限</el-button>
                            <el-button @click="removeAccount(scope.row)" link size="small">解绑</el-button>
                            <el-button :disabled="scope.row.Status=='SUSPENDED'" @click="closeAccount(scope.row)" link size="small">关闭</el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <el-dialog v-model="inviteVisible" :close-on-click-modal="false" title="邀请用户" width="660" :beforeClose="cancel">
            <div class="payerName">Payer信息：{{ curPayer }}</div>
            
            <el-row v-for="(item,index) in inviteForm" :key="index">
                <el-form :inline="false" :model="item" :rules="rules" ref="inviteForm" style="display:flex;" label-position="right" label-width="auto">
                    <el-form-item style="width:20px;">
                        {{ index+1+'、' }}
                    </el-form-item>
                    <el-form-item label="邀请类型" prop="Type">
                        <el-select v-model="item.Type" placeholder="请选择类型" style="width:160px;">
                            <el-option v-for="bg in this.accOptions" :label="bg.label" :value="bg.value" :key="bg.value">{{bg.label}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="账户信息" prop="Id" style="margin-left:30px;">
                        <el-input v-model="item.Id" style="width:160px;"></el-input>
                    </el-form-item>
                    <el-form-item style="margin-left:20px;" label="" v-if="inviteForm.length>1&&!isEditInvite">
                        <el-button icon="Minus" type="danger" @click="removeForm(index)"></el-button>
                    </el-form-item>
                    <el-form-item style="margin-left:10px;" label="" v-if="index == (inviteForm.length - 1)&&!isEditInvite">
                        <el-button icon="Plus" type="primary" @click="newForm()"></el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <template #footer>
                <el-button @click="cancel()">取消</el-button>
                <el-button type="primary" @click="inviteLink()">提交</el-button>
            </template>
        </el-dialog>
        <el-dialog v-model="policyVisible" :close-on-click-modal="false" title="策略管理" width="60%">
            <el-form :inline="true" :model="formInline1" label-position="left">
                <el-form-item label="策略名称：">
                    <el-input v-model="formInline1.name" clearable style="width:120px" placeholder="输入策略名称查询"></el-input>   
                </el-form-item>
                <el-form-item><el-button  @click="getPolicyList" type="primary" icon="Search">查询</el-button></el-form-item>
                <el-form-item><el-button  @click="addP" type="success" icon="Plus">新增</el-button></el-form-item>
            </el-form>
            <el-table :data="policyData" stripe>
                <el-table-column prop="name" label="策略名称" width="180"></el-table-column>
                <el-table-column prop="descr" label="描述" width="280"></el-table-column>
                <el-table-column align="center" label="操作">
                    <template #default="scope">
                        <el-button @click="editP(scope.row)" icon="Edit" type="primary"></el-button>
                        <el-button @click="removeP(scope.row)" icon="Delete" type="danger"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top:20px;justify-content: center;" small v-model:current-page="pageparm.page"  layout="prev, pager, next" :total="pageparm.total" @current-change="handleCurrentChange"/>
            <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
        </el-dialog>
        
        <el-dialog v-model="policyVisible1" :close-on-click-modal="false" :title="isEditPolicy?'修改策略':'新增策略'" width="560px">
            <el-form :inline="false" :model="policyForm" ref="policyForm" label-position="right" label-width="auto">
                <el-form-item label="策略名称：" prop="name">
                    <el-input v-model="policyForm.name" placeholder="请输入策略名称"></el-input>
                </el-form-item>
                <el-form-item label="策略描述：" prop="descr">
                    <el-input v-model="policyForm.descr" placeholder="请输入描述"></el-input>
                </el-form-item>
                <el-form-item label="策略：" prop="content">
                    <el-input v-model="policyForm.content" type="textarea" :rows="5" placeholder="请输入策略"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="cancel()">取消</el-button>
                <el-button type="primary" @click="addPolicySubmit()">确定</el-button>
            </template>
        </el-dialog>
        <el-dialog v-model="attachPolicyVisible" title="绑定策略" width="60%">
            <div class="payerName">当前Linker信息：{{ targetId }}</div>
            <el-table v-loading="policiesLoading" :data="allPolicyData" stripe style="width: 100%">
                <el-table-column prop="name" label="名称" width="300">
                </el-table-column>
                <el-table-column prop="descr" label="描述">
                </el-table-column>
                <el-table-column prop="type" label="来源" width="100">
                </el-table-column>
                <el-table-column label="继承自" width="150">
                    <template #default="scope">
                        <div v-if="scope.row.inherited">
                            <el-tag v-if="scope.row.inherited_from_type === 'ROOT'" type="warning" size="small">Root</el-tag>
                            <el-tag v-else-if="scope.row.inherited_from_type === 'OU'" type="info" size="small">OU</el-tag>
                            <div v-if="scope.row.inherited_from" class="inherited-from-id" style="font-size: 11px; color: #666; margin-top: 2px;">
                                {{ scope.row.inherited_from }}
                            </div>
                        </div>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="80">
                    <template #default="scope">
                        <el-switch 
                            v-model="scope.row.switch" 
                            active-color="#13ce66" 
                            inactive-color="#ff4949"
                            :disabled="scope.row.inherited"
                            @change="changeOnSwitchBtn(scope.row)">
                        </el-switch>
                        <div v-if="scope.row.inherited" style="font-size: 11px; color: #999; margin-top: 2px;">
                            继承策略
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="最近的邀请" v-model="showStateDialog">
            <el-table height="350" v-loading="stateLoading" :data="stateGroup" stripe style="width: 100%">
                <el-table-column prop="LinkId" label="电子邮件地址或账户 ID">
                </el-table-column>
                <el-table-column prop="RequestedTimestamp" label="请求日期" :formatter="formatTimestamp1">
                </el-table-column>
                <el-table-column prop="ExpirationTimestamp" label="过期日期" :formatter="formatTimestamp2">
                </el-table-column>
                <el-table-column prop="State" label="状态">
                    <template #default="scope">
                        <el-tag :type="scope.row.State === 'ACCEPTED' ? 'success' : 'danger'" disable-transitions>
                            {{ scope.row.State }}
                        </el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="邀请列表" v-model="inviteDialog" width="80%">
            <el-table height="350" v-loading="inviteLoading" :data="inviteData" stripe style="width: 100%">
                <el-table-column prop="" label="Payer信息">
                    <template #default="scope">
                        {{scope.row.payerName+'('+scope.row.payerId+')'}}
                    </template>
                </el-table-column>
                <el-table-column prop="account" label="LinkId或邮箱">
                </el-table-column>
                <el-table-column prop="" label="邀请人">
                    <template #default="scope">
                        {{scope.row.sales?scope.row.sales:scope.row.agentName+'('+scope.row.agentId+')'}}
                    </template>
                </el-table-column>
                <el-table-column prop="reason" label="拒绝原因">
                </el-table-column>
                <el-table-column prop="State" label="状态">
                    <template #default="scope">
                        <el-tag :type="scope.row.status==2?'danger':'success'" disable-transitions>
                            <span v-if="scope.row.status==0">{{scope.row.sales?'销售发起':'伙伴发起'}}</span>
                            <span v-if="scope.row.status==1">管理员同意</span>
                            <span v-if="scope.row.status==2">管理员拒绝</span>
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="State" label="操作">
                    <template #default="scope">
                        <div v-if="curRole == 'admin'">
                            <el-button title="同意" :disabled="scope.row.status==2" type="success" link @click="agree(scope.row)"><el-icon style="font-size:16px;"><CircleCheckFilled /></el-icon></el-button>
                            <el-button title="拒绝" :disabled="scope.row.status==2" type="danger" link @click="disagree(scope.row)"><el-icon style="font-size:16px;"><CircleCloseFilled /></el-icon></el-button>
                            <el-button title="删除" type="danger" link @click="removeInvite(scope.row)"><el-icon><Delete /></el-icon></el-button>
                        </div>
                        <div v-if="(curRole == 'agent'||curRole=='sales')">
                            <el-button title="编辑" type="primary" link @click="editInvite(scope.row)"><el-icon><Edit /></el-icon></el-button>
                            <el-button title="删除" type="danger" link @click="removeInvite(scope.row)"><el-icon><Delete /></el-icon></el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="拒绝原因" v-model="denyVisible">
            <el-input v-model="reason" type="textarea" placeholder="请输入拒绝原因"></el-input>
            <template #footer>
                <el-button @click="cancel()">取消</el-button>
                <el-button type="primary" @click="denySubmit()">确定</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination";
    import {getPayerList,getAccountList,listPolicyAws,attachAwsPolicyWithLink,detachAwsPolicyWithLink,listPolicy,addPolicy,removePolicy,
        getInviteStatus,inviteAccount,inviteAccountLocal,inviteList,deleteInvite,agreeInvite,denyInvite,removeAccountFromOrg,closeAccountFromOrg,
        getAgentList,getSalesList,createOU,deleteOU,listPolicyForTarget,listRoots,listOU,listChildren} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    import qs from 'qs'
    import moment from 'moment';
    export default {
        components:{
            Pagination
        },
        name:'organizationManage',
        data() {
            //定义输入校验
            var type='';
            var validateSelect =(rule,value,callback) =>{
                if(value === ''){
                    callback(new Error('请选择邀请类型'));
                }else{
                    type = value
                }
            }
            var validateInput = (rule, value, callback) => {
                if(type==''){
                    callback(new Error('请先选择邀请类型'));
                }else{
                    if (value === '') {
                        callback(new Error('请输入账户信息'));
                    }else{
                        var reg = /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]+[.]{1})+[a-zA-Z]+$/;
                        var reg1 = /^\d{12}$/;
                        if(type=='EMAIL'){
                            if(!reg.test(value)){
                                callback(new Error('请输入正确的邮箱'));
                                return false;
                            }
                        }else if(type=='ACCOUNT'){
                            if(!reg1.test(value)){
                                callback(new Error('请输入12位标准的ID'));
                                return false;
                            }
                        }
                        callback();
                    }
                }
                
            };
            
            return {
                loadingPage:false,
                linkListLoading:false,
                tableHeight:500,
                formInline:{
                    agent_id:'',
                    sales:'',
                    region:'cn',
                    payer_id:'',
                    page:1,
                    limit:20,
                },
                tableData:[],
                salesList:[],
                agentsList:[],
                regionList:[
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'}
                ],
                curRole:localStorage.getItem('curRole'),
                props: {
                    label: 'name',
                    children: 'zones',
                    isLeaf:(data,node)=>{
                        if(node.level>1){
                            return true;
                        }
                    }
                },
                node:null,
                nodeLevel1:null,
                resolveFunc:null,
                accountGroup:null,
                inviteForm:[{
                    Type:'',
                    Id:''
                }], 
                myForm:{
                    Type:'',
                    Id:''
                },
                curPayer:'',
                curPayerId:'',
                inviteVisible:false,
                policyVisible:false,
                policyData:[],
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                formInline1:{
                    name:'',
                    type:'',
                    page:1,
                    limit:10,
                },
                policyVisible1:false,
                policyForm:{
                    name:'',
                    descr:'',
                    content:'',
                },
                isEditPolicy:false,
                allPolicyData:[],
                linkPolicyData:[],
                attachPolicyVisible:false,
                curPolicy:'',
                targetId:'',
                policiesList:[],
                showStateDialog:false,
                stateGroup:[],
                policiesLoading:false,
                
                accOptions: [{
                    value: 'EMAIL',
                    label: '注册邮箱'
                }, {
                    value: 'ACCOUNT',
                    label: 'AWS ID'
                }],
                stateLoading:false,
                rules: {
                    Type:[
                        { required: true, trigger: 'change',validator: validateSelect}
                    ],
                    Id: [
                        { required: true, trigger: 'blur',validator: validateInput, }
                    ],
                },
                payerList:[],
                inviteDialog:false,
                inviteData:[],
                inviteLoading:false,
                isEditInvite:false,
                curInviteId:'',
                denyVisible:false,
                reason:'',
                treeTableData: [],
                showAccountCol: true,
                total: 0,
            }
        },

        methods:{
            loadNode(node,resolve){
                if (node.level === 0) {
                    this.node = node;
                    this.resolveFunc = resolve
                    this.loadingPage = true;
                    getPayerList(this.formInline).then(res=>{
                        if(res.code==2000){
                            this.loadingPage = false;
                            this.payerList = res.data.data;
                            return resolve(res.data.data);
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                    
                }else if(node.level==1){
                    this.linkListLoading = true;
                    if(this.nodeLevel1){
                        this.nodeLevel1.childNodes = [];
                        this.nodeLevel1.expanded = false;
                        this.nodeLevel1.loaded = false;
                        this.nodeLevel1.isLeaf = false;
                    }
                    this.nodeLevel1 = node;
                    getAccountList({payerId:node.data.payer_id}).then(res=>{
                        this.curPayer = node.data.name+'（'+node.data.payer_id+'）';
                        this.curPayerId = node.data.payer_id;
                        if(res.code==2000){
                            var arr=[];
                            res.data.forEach(el=>{
                                arr.push({
                                    name:el.Id
                                })
                            })
                            this.linkListLoading = false;
                            this.accountGroup = res.data;
                            return resolve(arr);
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }
            },
            getAccount(id){
                this.linkListLoading = true;
                getAccountList({payerId:id}).then(res=>{
                    if(res.code==2000){
                        var arr=[];
                        res.data.forEach(el=>{
                            arr.push({
                                name:el.Id
                            })
                        })
                        this.linkListLoading = false;
                        this.accountGroup = res.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            init(){
                this.formInline = {
                    agent_id:'',
                    sales:'',
                    region:'cn',
                    payer_id:'',
                    page:1,
                    limit:20,
                }
                this.getData()
            },
            // 获取payer列表
            async getData() {
                this.loadingPage = true;
                try {
                    const res = await getPayerList(this.formInline);
                    if (res.code === 2000) {
                        const payers = res.data.data || [];
                        this.total = res.data.total || 0;
                        this.pageparm.total = res.data.total || 0;
                        this.pageparm.page = res.data.page || 1;
                        this.pageparm.limit = res.data.limit || 20;
                        // 简化初始加载，不调用AWS API
                        this.treeTableData = payers.map(payer => ({
                            id: `payer_${payer.payer_id}`,
                            payer_id: payer.payer_id,
                            name: payer.name || '',
                            email: payer.email || '',
                            type: 'org',
                            hasChildren: true,
                            level: 0
                        }));
                    } else {
                        this.treeTableData = [];
                        this.total = 0;
                        this.$message.error(res.msg || '获取数据失败');
                    }
                } catch (error) {
                    console.error('getData error:', error);
                    this.treeTableData = [];
                    this.total = 0;
                    this.$message.error('获取数据失败');
                }
                this.loadingPage = false;
            },
            // 懒加载组织结构
            async loadOrgChildren(row, treeNode, resolve) {
                console.log('Loading children for row:', row);
                const loadingNode = this.$refs.orgTable.store.states.lazyTreeNodeMap[row.id];
                if (loadingNode) {
                    loadingNode.loading = true;
                }

                try {
                    if (row.type === 'org') {
                        // 当展开Payer节点时，先获取root ID
                        const rootRes = await listRoots({ payerId: row.payer_id });
                        if (rootRes.code !== 2000 || !rootRes.data.Roots) {
                            throw new Error('Failed to get root ID');
                        }
                        const rootId = rootRes.data.Roots[0].Id;
                        row.rootId = rootId; // 保存rootId供后续使用

                        // 创建Root OU节点
                        const rootOU = {
                            id: `ou_${row.payer_id}_${rootId}`,
                            originalId: rootId,
                            name: 'Root',
                            type: 'ou',
                            hasChildren: true,
                            level: row.level + 1,
                            payerId: row.payer_id,
                            parentId: null,
                            isRoot: true
                        };

                        // 只返回Root OU作为第一层
                        resolve([rootOU]);

                    } else if (row.type === 'ou') {
                        // 加载 OU 下的所有内容
                        const [childrenRes, ouRes, accountRes] = await Promise.all([
                            listChildren({ payerId: row.payerId, parentId: row.originalId || row.id }),
                            listOU({ payerId: row.payerId, parentId: row.originalId || row.id }),
                            getAccountList({ payerId: row.payerId })
                        ]);
                        
                        let children = [];
                        
                        // 添加子 OU
                        if (ouRes.code === 2000 && Array.isArray(ouRes.data.OrganizationalUnits)) {
                            const ous = ouRes.data.OrganizationalUnits.map(ou => ({
                                id: `ou_${row.payerId}_${ou.Id}`,
                                originalId: ou.Id,
                                name: ou.Name,
                                type: 'ou',
                                hasChildren: true,
                                level: row.level + 1,
                                payerId: row.payerId,
                                parentId: row.originalId || row.id
                            }));
                            children = children.concat(ous);
                        }
                        
                        // 添加 OU 下的账户
                        if (childrenRes.code === 2000 && Array.isArray(childrenRes.data.Children)) {
                            // 创建账户ID到详细信息的映射
                            const accountMap = {};
                            if (accountRes.code === 2000 && Array.isArray(accountRes.data)) {
                                accountRes.data.forEach(acc => {
                                    accountMap[acc.Id] = acc;
                                });
                            }

                            const accounts = childrenRes.data.Children
                                .filter(child => child.Type === 'ACCOUNT')
                                .map(child => {
                                    const accountInfo = accountMap[child.Id] || {};
                                    return {
                                        id: `account_${row.payerId}_${child.Id}`,
                                        originalId: child.Id,
                                        name: accountInfo.Name || child.Id,
                                        Email: accountInfo.Email || '',
                                        Id: child.Id,
                                        payerId: row.payerId,
                                        JoinedMethod: accountInfo.JoinedMethod || 'INVITED',
                                        JoinedTimestamp: accountInfo.JoinedTimestamp || child.JoinedTimestamp,
                                        Status: accountInfo.Status || 'ACTIVE',
                                        type: 'account',
                                        level: row.level + 1,
                                        hasChildren: false,
                                        parentId: row.originalId // 使用当前OU的originalId作为账户的parentId
                                    };
                                });
                            children = children.concat(accounts);
                        }

                        if (loadingNode) {
                            loadingNode.loading = false;
                        }
                        resolve(children);
                    } else {
                        if (loadingNode) {
                            loadingNode.loading = false;
                        }
                        resolve([]);
                    }
                } catch (error) {
                    console.error('loadOrgChildren error:', error);
                    this.$message.error('加载组织结构失败');
                    if (loadingNode) {
                        loadingNode.loading = false;
                    }
                    resolve([]);
                }
            },
            renderContent(h, { node, data, store }) {
                if(node.level==1){
                    return h('span', { class: 'custom-tree-node' }, [
                        h('span', { style: 'cursor:text' }, node.label),
                        h('span', {}, [
                            h('el-button', {
                                props: { type: 'primary', link: true },
                                style: 'margin-left:2px',
                                on: { click: () => this.showInvite(data) }
                            }, '邀请'),
                            h('el-button', {
                                props: { type: 'primary', link: true },
                                style: 'margin-left:2px',
                                on: { click: () => this.showAccountState(data) }
                            }, '状态')
                        ])
                    ]);
                }else{
                    return h('span', { class: 'custom-tree-node' }, [
                        h('span', {}, node.label)
                    ]);
                }
            },
            showInvite(data){
                this.curPayer = data.name+'（'+data.payer_id+'）';
                this.curPayerId = data.payer_id;
                this.inviteVisible = true;
                this.isEditInvite = false;
            },
            async showAccountState(cur){
                this.stateLoading = true;
                // 现请求接口，然后打开弹窗
                const {code,data} = await getInviteStatus({ payerId: cur.payer_id })
                if(code==2000){
                    this.stateGroup = data.Handshakes;
                    this.stateGroup.forEach(el=>{
                        el.Resources.forEach(el1=>{
                            if(el1.Type == 'ACCOUNT'||el1.Type == 'EMAIL'){
                                el.LinkId = el1.Value;
                            }
                        })
                    })
                    this.showStateDialog = true;
                    this.stateLoading = false;
                }
                
            },
            async changeOnSwitchBtn(policy) {
                this.policiesLoading = true;
                try {
                    if (policy.switch) {
                        const res = await attachAwsPolicyWithLink({
                            policyId: policy.id,
                            targetId: this.targetId,
                            payerId: this.curPayerId
                        });
                        if (res.code !== 2000) {
                            policy.switch = false;
                            throw new Error(res.msg);
                        }
                    } else {
                        const res = await detachAwsPolicyWithLink({
                            policyId: policy.id,
                            targetId: this.targetId,
                            payerId: this.curPayerId
                        });
                        if (res.code !== 2000) {
                            policy.switch = true;
                            throw new Error(res.msg);
                        }
                    }
                } catch (error) {
                    console.error('Policy operation error:', error);
                    this.$message.error('策略操作失败：' + error.message);
                } finally {
                    this.policiesLoading = false;
                }
            },
            async inviteLink(){
                var arr=[]
                this.inviteForm.forEach(el=>{
                    arr.push(el.Id)
                })
                var obj = null;
                if(this.curRole=='admin'){
                    obj =await inviteAccount(qs.stringify({linkId:arr.join(','),payerId:this.curPayerId}));
                }else{
                    var data={};
                    if(this.curRole=='sales'){
                        data={
                            account:arr.join(','),
                            payerId:this.curPayerId,
                            sales:localStorage.getItem('account')
                        }
                    }else if(this.curRole=='agent'){
                        data={
                            account:arr.join(','),
                            payerId:this.curPayerId,
                            agentId:localStorage.getItem('account')
                        }
                    }
                    if(this.isEditInvite){
                        data.id = this.curInviteId
                    }
                    obj = await inviteAccountLocal(qs.stringify(data));
                }
                if(obj.code==2000){
                    if(this.isEditInvite){
                        this.$message.success('修改成功！');
                        this.getInviteList()
                    }else{
                        this.$message.success('邀请成功！');
                    }
                    this.cancel();
                }else{
                    this.$message.error(JSON.stringify(obj.msg))
                }
            },
            newForm(){
                this.inviteForm.push({
                    Type:'',
                    Id:''
                })
            },
            removeForm(index){
                this.$confirm('该操作将会清空选中表单，确定移出吗？','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消'
                }).then(()=>{
                    this.inviteForm = this.inviteForm.filter((ite,ind)=>{
                        return ind!=index;
                    })
                })
            },
            async showPolicy(data) {
                this.linkListLoading = true;
                try {
                    // 确保先设置 payerId
                    this.curPayerId = data.payerId;
                    // 使用原始ID而不是组合ID
                    this.targetId = data.originalId || data.Id;
                    
                    // 获取当前节点的策略（包含继承的策略）
                    await this.getAllPolicyList();
                    
                    try {
                        // 获取当前节点的策略，包含继承的策略
                        const policyResponse = await listPolicyForTarget({
                            payer_id: this.curPayerId,
                            target_id: this.targetId,
                            include_inherited: true
                        });
                        
                        if (policyResponse.code === 2000 && policyResponse.data) {
                            this.policyList = policyResponse.data;
                            // 清空之前的继承策略列表，因为现在统一在policyList中处理
                            this.inheritedPolicyList = [];
                        }
                    } catch (error) {
                        console.error('Failed to get target policies:', error);
                        // 如果新接口失败，回退到旧的方式
                        await this.fallbackToOldPolicyMethod(data);
                    }
                    
                    this.attachPolicyVisible = true;
                } catch (error) {
                    console.error('showPolicy error:', error);
                    this.$message.error('Failed to load policies');
                } finally {
                    this.linkListLoading = false;
                }
            },
            
            // 回退到旧的权限获取方式（兼容性处理）
            async fallbackToOldPolicyMethod(data) {
                try {
                    // 获取当前节点的直接策略
                    const policyResponse = await listPolicyForTarget({
                        payer_id: this.curPayerId,
                        target_id: this.targetId,
                        include_inherited: false
                    });
                    
                    if (policyResponse.code === 2000 && policyResponse.data) {
                        this.policyList = policyResponse.data;
                    }
                    
                    // 如果是账户，获取其所在OU的继承策略
                    if (data.type === 'account' && data.parentId) {
                        try {
                            const ouPolicies = await listPolicyForTarget({
                                payer_id: this.curPayerId,
                                target_id: data.parentId,
                                include_inherited: false
                            });
                            
                            if (ouPolicies.code === 2000 && ouPolicies.data) {
                                this.inheritedPolicyList = ouPolicies.data;
                            }
                        } catch (error) {
                            console.warn('OU policies not available:', error);
                        }
                    }
                } catch (error) {
                    console.error('Fallback policy method failed:', error);
                }
            },
            removeAccount(account) {
                // 显示确认框，等待用户确认
                this.$confirm('确认要与Payer解除绑定吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async()=>{
                    // 用户点击确定按钮，执行异步操作
                    const {code,data} = await removeAccountFromOrg({linkId: account.Id,payerId:this.curPayerId});

                    if (code === 2000) {
                        this.$message({
                            message: '已与Payer解除绑定',
                            type: 'success'
                        })
                        this.getAccount(this.curPayerId)
                    } else {
                        this.$message({
                            message: obj.msg,
                            type: 'error'
                        })
                    }
                })
            },
            closeAccount(account) {
                this.closeAccountvisible = true
                this.$confirm('确认要关闭账号吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async()=>{
                    try {
                        this.$message({
                            message: '发送中...',
                            type: 'info'
                        })
                        const obj = await closeAccountFromOrg({ linkId:account.Id,payerId:this.curPayerId })
                        if (obj.code === 2000) {
                            this.$message({
                                message: '成功关闭' + account.Id,
                                type: 'success'
                            })
                            this.getAccount(this.curPayerId)
                        } else {
                            this.$message({
                                message: obj.msg,
                                type: 'error'
                            })
                        }
                    } catch (e) {
                        this.$message({
                            message: '发送失败',
                            type: 'error'
                        })
                    } finally {
                        this.closeAccountvisible = false
                    }
                })
            },
            async getListPolicyWithLink(id) {
                try {
                    // 使用新的接口获取策略状态，包含继承信息
                    const res = await listPolicyForTarget({
                        payer_id: this.curPayerId,
                        target_id: id,
                        include_inherited: true
                    });
                    
                    if(res.code === 2000) {
                        const policies = res.data || [];
                        this.allPolicyData = this.allPolicyData.map(item => {
                            const matchedPolicy = policies.find(p => p.Id === item.id);
                            return {
                                ...item,
                                switch: !!matchedPolicy,
                                inherited: matchedPolicy?.inherited || false,
                                inherited_from_type: matchedPolicy?.inherited_from_type || null,
                                inherited_from: matchedPolicy?.inherited_from || null
                            };
                        });
                    } else {
                        console.error('Policy with link error:', res);
                        // 如果新接口失败，回退到旧接口
                        await this.fallbackGetListPolicyWithLink(id);
                    }
                } catch (error) {
                    console.error('getListPolicyWithLink error:', error);
                    // 如果出错，回退到旧接口
                    await this.fallbackGetListPolicyWithLink(id);
                }
            },
            
            // 回退到旧的策略状态获取方式
            async fallbackGetListPolicyWithLink(id) {
                try {
                    const res = await listPolicyAws({targetId: id, payerId: this.curPayerId});
                    if(res.code === 2000) {
                        const policies = res.data?.Policies || [];
                        this.allPolicyData = this.allPolicyData.map(item => ({
                            ...item,
                            switch: this.hasKeyVaule(policies, 'Id', item.id),
                            inherited: false,
                            inherited_from_type: null,
                            inherited_from: null
                        }));
                    } else {
                        console.error('Fallback policy with link error:', res);
                        // 如果是payer not found的错误，我们将所有策略的switch设置为false
                        if(res.msg === 'payer not founded.') {
                            this.allPolicyData = this.allPolicyData.map(item => ({
                                ...item,
                                switch: false,
                                inherited: false,
                                inherited_from_type: null,
                                inherited_from: null
                            }));
                        } else {
                            this.$message.error('获取策略关联状态失败');
                        }
                    }
                } catch (error) {
                    console.error('fallbackGetListPolicyWithLink error:', error);
                    this.$message.error('获取策略关联状态失败');
                }
            },
            hasKeyVaule(array, key, value) {
                if (!Array.isArray(array)) {
                    return false;
                }
                return array.some(obj => {
                    if (!obj) {
                        return false;
                    }
                    return Object.keys(obj).some(keyName => {
                        return keyName === key && obj[keyName] === value;
                    });
                });
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                tabSelectHeight = this.isFull?tabSelectHeight - 110:tabSelectHeight
                this.tableHeight =  getTableHeight(tabSelectHeight)
            },
            // 修改时间格式
            formatTimestamp(timestamp) {
                if (!timestamp || !timestamp.JoinedTimestamp) {
                    return '-';
                }
                return moment(timestamp.JoinedTimestamp).format('YYYY/MM/DD - HH:mm:ss');
            },
            formatTimestamp1(timestamp) {
                if (!timestamp || !timestamp.RequestedTimestamp) {
                    return '-';
                }
                return moment(timestamp.RequestedTimestamp).format('YYYY/MM/DD - HH:mm:ss');
            },
            formatTimestamp2(timestamp) {
                if (!timestamp || !timestamp.ExpirationTimestamp) {
                    return '-';
                }
                return moment(timestamp.ExpirationTimestamp).format('YYYY/MM/DD - HH:mm:ss');
            },
            getPolicyList(){
                listPolicy(this.formInline1).then(res=>{
                    if(res.code==2000){
                        this.policyVisible = true;
                        this.policyData = res.data;
                        this.pageparm.total = res.total;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            // 获取销售和伙伴的邀请列表
            async getInviteList(){
                this.inviteDialog = true;
                this.inviteLoading = true;
                const {code,data,msg} = await inviteList();
                if(code=='2000'){
                    this.inviteData = data;
                    this.inviteLoading = false;
                }else{
                    this.$message.error(JSON.stringify(msg));
                }
            },
            agree(row){
                this.$confirm('确定同意该邀请吗？','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消'
                }).then(async()=>{
                    const {code,data} = await agreeInvite({id:row.id});
                    if(code == 2000){
                        this.$message.success('提交成功！');
                        this.getInviteList();
                    }else{
                        this.$message.error('提交失败！');
                    }
                })
            },
            disagree(row){
                this.denyVisible = true;
                this.reason = '';
                this.curInviteId = row.id;
            },
            async denySubmit(){
                const {code,data} = await denyInvite({id:this.curInviteId,reason:this.reason});
                if(code == 2000){
                    this.$message.success('提交成功！');
                    this.denyVisible = false;
                    this.reason = '';
                    this.getInviteList()
                }else{
                    this.$message.error('拒绝失败！')
                }
            },
            editInvite(row){
                this.curInviteId = row.id;
                this.isEditInvite = true;
                this.inviteForm=[{
                    Id:row.account,
                }];
                if(row.account.indexOf('@')!=-1){
                    this.inviteForm[0].Type='EMAIL'
                }else{
                    this.inviteForm[0].Type='ACCOUNT'
                }
                this.curPayerId = row.payerId;
                this.inviteVisible = true;
            },
            removeInvite(row){
                this.$confirm('确定删除该邀请吗？','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消'
                }).then(async()=>{
                    const {code,data} = await deleteInvite({id:row.id});
                    if(code == 2000){
                        this.$message.success('删除成功！');
                        this.getInviteList();
                    }else{
                        this.$message.error('删除失败！');
                    }
                })
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.pageparm.page = parm.page
                this.pageparm.limit = parm.limit
                this.getData()
            },
            async getAllPolicyList() {
                try {
                    if (!this.curPayerId) {
                        throw new Error('No Payer ID provided');
                    }

                    // 获取本地策略
                    const localPolicyRes = await listPolicy({page:1,limit:9999});
                    let list1 = [];
                    if(localPolicyRes.code==2000 && Array.isArray(localPolicyRes.data)){
                        list1 = localPolicyRes.data.map(el => ({
                            content: el.content || '',
                            descr: el.descr || '',
                            id: el.id,
                            name: el.name || '',
                            type: 'Local',
                            switch: false
                        }));
                    } else {
                        console.error('Local policy response error:', localPolicyRes);
                        this.$message.error('获取本地策略失败');
                    }

                    // 获取AWS策略
                    const awsPolicyRes = await listPolicyAws({payerId:this.curPayerId});
                    let list2 = [];
                    if(awsPolicyRes.code==2000){
                        // 如果是payer not found，这是正常情况，不需要显示错误
                        if(awsPolicyRes.msg === 'payer not founded.') {
                            console.info('No AWS policies found for this payer');
                        } 
                        // 如果有Policies数组，处理数据
                        else if(Array.isArray(awsPolicyRes.data?.Policies)) {
                            list2 = awsPolicyRes.data.Policies.map(el => ({
                                content: '',
                                descr: el.Description || '',
                                id: el.Id,
                                name: el.Name || '',
                                type: 'AWS',
                                switch: false
                            }));
                        }
                    } else if (awsPolicyRes.code === 404) {
                        console.info('AWS policy service not available for this payer');
                    } else {
                        console.error('AWS policy response error:', awsPolicyRes);
                        this.$message.error('获取AWS策略失败');
                    }

                    // 合并并去重
                    this.allPolicyData = list2.concat(list1);
                    const map = new Map();
                    for(let item of this.allPolicyData){
                        if(!map.has(item.name)){
                            map.set(item.name,item);
                        }
                    }
                    this.allPolicyData = [...map.values()];

                    // 获取当前目标的策略状态
                    await this.getListPolicyWithLink(this.targetId);
                } catch (error) {
                    console.error('getAllPolicyList error:', error);
                    if (error.message === 'No Payer ID provided') {
                        this.$message.error('未提供有效的Payer ID');
                    } else {
                        this.$message.error('获取策略列表失败');
                    }
                    this.allPolicyData = [];
                }
            },
            addP(){
                this.policyVisible1 = true;
                this.isEditPolicy = false;
            },
            editP(row){
                this.policyForm = JSON.parse(JSON.stringify(row));
                this.isEditPolicy = true;
                this.policyVisible1 = true;
            },
            removeP(row){
                this.$confirm('该策略可能绑定有Linker，确定删除吗？','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消'
                }).then(()=>{
                    removePolicy({id:row.id}).then(res=>{
                        if(res.code==2000){
                            this.$message.success('删除成功！');
                            this.getPolicyList()
                        }else{
                            this.$message.error(JSON.stringify(res.msg))
                        }
                    })
                })
            },
            cancel(){
                this.policyForm={
                    name:'',
                    content:'',
                    descr:'',
                };
                this.inviteForm=[{
                    Type:'',
                    Id:''
                }];
                this.attachPolicyVisible = false,
                this.curPolicy = '';
                this.inviteVisible = false;
                this.policyVisible1 = false;
            },
            addPolicySubmit(){
                addPolicy(this.policyForm).then(res=>{
                    if(res.code==2000){
                        if(this.isEditPolicy){
                            this.$message.success('修改成功！');
                        }else{
                            this.$message.success('添加成功！');
                        }
                        this.policyVisible1 = false
                        this.getPolicyList()
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            permissionData(){
                if(this.curRole=='admin'){
                    this.getAgentsList();
                    this.getSaleList();
                }else if(this.curRole == 'sales'){
                    this.getAgentsList();
                }
                // 所有角色都需要获取 Payer 列表
                this.getPayersList();
            },
            // 获取伙伴列表
            getAgentsList(){
                getAgentList({company:'',payers:'',sales:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.agentsList = res.data.data;
                    }else{
                        this.$message.error('获取伙伴列表失败！');
                    }
                })
            }, 
            // 获取销售列表
            getSaleList(){
                getSalesList({name:'',phone:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.salesList = res.data.data;
                    }else{
                        this.$message.error('获取销售列表失败！');
                    }
                })
            },
            // 获取payer列表
            getPayersList(){
                getPayerList({name:'',payer_id:'',region:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.payerList = res.data.data;
                    }else{
                        this.$message.error('获取Payer列表失败！');
                    }
                })
            },
            // OU 相关方法
            async createNewOU(row) {
                try {
                    const name = await this.$prompt('请输入OU名称', '新建OU', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPattern: /^[a-zA-Z0-9\-_]+$/,
                        inputErrorMessage: '名称只能包含字母、数字、横线和下划线'
                    });
                    
                    if (name.value) {
                        const res = await createOU({
                            payerId: row.payer_id,
                            parentId: row.rootId,
                            name: name.value
                        });
                        
                        if (res.code === 2000) {
                            this.$message.success('OU创建成功');
                            // 刷新当前节点
                            this.$refs.orgTable.store.states.lazyTreeNodeMap[row.id] = [];
                            this.$refs.orgTable.store.loadOrToggle(row);
                        } else {
                            this.$message.error(res.msg || '创建失败');
                        }
                    }
                } catch (error) {
                    if (error !== 'cancel') {
                        console.error('createNewOU error:', error);
                        this.$message.error('创建OU失败');
                    }
                }
            },
            
            async deleteOUHandler(row) {
                try {
                    await this.$confirm('删除OU将会同时删除其下所有账户的关联关系，是否继续？', '警告', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    });
                    
                    const res = await deleteOU({
                        payerId: row.payerId,
                        orgId: row.id
                    });
                    
                    if (res.code === 2000) {
                        this.$message.success('OU删除成功');
                        // 刷新父节点
                        if (row.parentId) {
                            this.$refs.orgTable.store.states.lazyTreeNodeMap[row.parentId] = [];
                            const parentNode = this.findNodeByKey(row.parentId);
                            if (parentNode) {
                                this.$refs.orgTable.store.loadOrToggle(parentNode);
                            }
                        }
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                } catch (error) {
                    if (error !== 'cancel') {
                        console.error('deleteOU error:', error);
                        this.$message.error('删除OU失败');
                    }
                }
            },
            
            findNodeByKey(key) {
                const nodeMap = this.$refs.orgTable.store.states.treeData;
                for (const nodeKey in nodeMap) {
                    if (nodeMap[nodeKey].data.id === key) {
                        return nodeMap[nodeKey].data;
                    }
                }
                return null;
            },
        },
        created() {
            this.permissionData()
            if(this.curRole=='sales'){
                this.formInline.sales = localStorage.getItem('account');
            }else if(this.curRole=='agent'){
                this.formInline.agent_id = localStorage.getItem('account');
            }
            // 初始化时获取 Payer 列表
            this.getPayersList();
        },
        mounted() {
            this.getData();
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
<style lang="scss">
</style>
